import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { buttonVariants } from '@/components/ui/button'
import Card from 'app/frontend/base/components/Card'
import { usePageInfo, useGlobalNewsItems } from '../../../../config/queries'
import NewsTagBadge from '../../../News/NewsTagBadge'
import Reveal from './Reveal'

const CARD_CLASS = 'flex h-24 items-center gap-3 p-3'

const NewsCardSkeleton = () => (
  <Card className={CARD_CLASS}>
    <div className='w-24 h-full shrink-0 rounded-md bg-muted animate-pulse' />
    <div className='flex flex-col gap-2 min-w-0 flex-1'>
      <div className='h-3.5 w-3/4 rounded bg-muted animate-pulse' />
      <div className='h-3.5 w-1/2 rounded bg-muted animate-pulse' />
      <div className='h-5 w-14 rounded-full bg-muted animate-pulse' />
    </div>
  </Card>
)

const HomeNewsSection = () => {
  const { t } = useTranslation()
  const {
    data: { user },
  } = usePageInfo()
  const { data: newsItems, isPending } = useGlobalNewsItems()

  if (!user) return null

  const posts = (newsItems ?? []).filter((item) => item.published).slice(0, 3)

  if (!isPending && posts.length === 0) return null

  return (
    <Reveal y={16}>
      <section className='flex flex-col gap-2'>
        <div className='flex items-center justify-between gap-4'>
          <h4 className='text-base font-medium text-foreground mb-0'>
            {t('homepage.news-heading')}
          </h4>
          <Link
            to='/news'
            className={buttonVariants({ variant: 'outline', size: 'xs' })}
          >
            {t('homepage.news-view-all')}
          </Link>
        </div>

        <div className='grid gap-2 md:grid-cols-3'>
          {isPending
            ? [0, 1, 2].map((i) => <NewsCardSkeleton key={i} />)
            : posts.map((post) => (
                <Link
                  key={post.id}
                  to={`/news/${post.id}`}
                  className='block h-full'
                >
                  <Card
                    className={`${CARD_CLASS} transition-colors hover:border-primary/40`}
                  >
                    {post.mainImageUrl && (
                      <img
                        src={post.mainImageUrl}
                        alt={post.title}
                        className='w-24 h-full object-cover rounded-md border border-border shrink-0'
                      />
                    )}
                    <div className='flex flex-col gap-1.5 min-w-0'>
                      <h3 className='mb-0 text-base font-medium leading-tight line-clamp-2'>
                        {post.title}
                      </h3>
                      {post.tags.length > 0 && (
                        <div className='flex flex-wrap gap-1'>
                          {post.tags.map((tag) => (
                            <NewsTagBadge key={tag} tag={tag} />
                          ))}
                        </div>
                      )}
                    </div>
                  </Card>
                </Link>
              ))}
        </div>
      </section>
    </Reveal>
  )
}

export default HomeNewsSection
